// @ts-nocheck
import React, { useCallback } from 'react';
import {
  Box,
  IconButton,
  DialogContent,
  Dialog,
  DialogTitle,
  Typography,
  Grid,
  Tooltip,
} from '@mui/material';
import { ReactComponent as CloseIcon } from '../../../../assets/Icons/lucideIcons/x.svg';
import { ReactComponent as FullscreenIcon } from '../../../../assets/Icons/lucideIcons/maximize.svg';
import { ReactComponent as FullscreenExitIcon } from '../../../../assets/Icons/lucideIcons/minimize.svg';
import PropTypes from 'prop-types';

import AdvancedTableViewer from '../../AdvancedTableViewer';
import useModalDisclosure from '../../../../hooks/useModalDisclosure';
import { useDialogFullscreen } from '../../../../hooks/useDialogFullscreen';

const ViewAdvancedTable = ({ value, attribute, entityId, entityType }) => {
  const {
    open: openPreview,
    handleOpen: openModal,
    handleClose: closeModal,
  } = useModalDisclosure();
  const { isFullScreen, toggleFullScreen, exitFullScreen } =
    useDialogFullscreen();

  const handleClosePreview = useCallback(() => {
    closeModal();
  }, [closeModal]);

  const handleOpenPreview = useCallback(() => {
    openModal();
  }, [openModal]);

  return (
    <Grid container size={12}>
      <Grid size={12}>
        <Typography
          variant="body2"
          component="span"
          onClick={handleOpenPreview}
          sx={{
            color: 'primary.main',
            cursor: 'pointer',
            textDecoration: 'underline',
          }}
        >
          View {attribute?.label || 'Advanced Table'}
        </Typography>
      </Grid>

      <Dialog
        open={openPreview}
        onClose={handleClosePreview}
        maxWidth={isFullScreen ? false : 'lg'}
        fullWidth
        fullScreen={isFullScreen}
        slotProps={{
          transition: {
            onExited: () => exitFullScreen(),
          },

          paper: {
            sx: {
              maxHeight: isFullScreen ? '100vh' : '90vh',
              height: isFullScreen ? '100vh' : 'auto',
            },
          },
        }}
      >
        <DialogTitle>
          <Box component="span" aria-live="polite" aria-atomic="true">
            {attribute?.label}
          </Box>
        </DialogTitle>

        {/* Fullscreen Button */}
        <Tooltip title={isFullScreen ? 'Exit Full Screen' : 'Full Screen'}>
          <IconButton
            color="primary"
            aria-label={isFullScreen ? 'Exit full screen' : 'Enter full screen'}
            onClick={toggleFullScreen}
            sx={{
              position: 'absolute',
              right: 56,
              top: 8,
            }}
          >
            {isFullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
          </IconButton>
        </Tooltip>

        <IconButton
          color="primary"
          aria-label="Close dialog"
          onClick={handleClosePreview}
          sx={{
            position: 'absolute',
            right: 16,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <AdvancedTableViewer
            attribute={attribute}
            value={value}
            entityId={entityId}
            entityType={entityType}
          />
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

ViewAdvancedTable.propTypes = {
  value: PropTypes.shape({
    Cells: PropTypes.shape({}),
  }).isRequired,
  attribute: PropTypes.shape({
    label: PropTypes.string,
  }).isRequired,
  entityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  entityType: PropTypes.string,
};

export default ViewAdvancedTable;
